
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-20426.494 -13671.995 19.479 19.607"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_6_1","data-name":"Symbol 6 – 1","transform":"translate(-20425.504 -13671.005)"}},[_c('g',{attrs:{"id":"Group_42","data-name":"Group 42","opacity":".87"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Line_11","d":"M0 3.628L3.628 0","data-name":"Line 11","transform":"translate(0 13.999)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_12","d":"M0 3.628L3.585 0","data-name":"Line 12","transform":"translate(8.579)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_13","d":"M0 3.628L3.628 0","data-name":"Line 13","transform":"translate(13.871 5.292)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_14","d":"M0 0l10.969 10.969","data-name":"Line 14","transform":"translate(5.463 1.024)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_73","d":"M7.213 17.888l-2.22-2.219a5.332 5.332 0 0 1 0-7.554L8.408 4.7l9.774 9.816-3.414 3.414a5.371 5.371 0 0 1-7.555-.042z","data-name":"Path 73","transform":"translate(-2.39 -3.121)"}})])])])
          )
        }
      }
    